export default __webpack_public_path__ + "assets/images/dcc44e7017535e1446a0dfc685a6ff46.png";